import module from 'colaborador/module.js'

const schema = {
  indice: 'number',
  fecha_inicial: 'date',
  fecha_final: 'date',
  duracion: 'number',
  pagos: {
    fecha_inicial: 'date',
    fecha_final: 'date',
    dias_pagados: 'number',
    importe: 'number',
  },
}

export class ColaboradorIncapacidadesService {
  constructor ($http) {
    this.$http = $http
  }

  get (idProyecto, idColaborador) {
    return this.$http.get('/api/colaborador/incapacidades', {
      params: {id_proyecto: idProyecto, id_colaborador: idColaborador},
      schema,
      cache: 'colaborador',
    })
  }

  post (idProyecto, idColaborador, data) {
    return this.$http.post('/api/colaborador/incapacidades', data, {
      params: {id_proyecto: idProyecto, id_colaborador: idColaborador},
      schema,
      clearCache: 'colaborador',
    })
  }
}

module.service('ColaboradorIncapacidades', ColaboradorIncapacidadesService)



// WEBPACK FOOTER //
// ./src/colaborador/services/Colaborador/Incapacidades.js